import angular from 'angular';
import ngRedux from 'ng-redux';

import 'angular-bootstrap';
import 'ng-s3upload';

import creativeList from './list.directive';
import creativeIcon from './icon.directive';
import CreativeFormValidationService from './form_validation.service';
import exampleCreatives from './example_creatives.directive';
import userCreatives from './user_creatives.directive';
import UserCreativesController from './user_creatives.controller';
import CreativeListController from './list.controller';
import CreativeListService from './list.service';
import CreativeService from './service';
import CreativeGroupService from './group.service';
import NameCreativeGroupModalController from './name_creative_group.modal.controller';
import reduxConfig from '../reduxConfig';
import SaveCreativeService from './save_creative.service';

// TODO: refactor: article content module?
import OpenGraphDataService from '../article_content/open_graph.data_service';

angular.module('generator.creatives', [
  'generator.shared',
  'ngFileUpload',
  'ngS3upload',
  'ui.bootstrap',
  ngRedux
]);

angular
  .module('generator.creatives')
  .config(reduxConfig)
  .controller('CreativeListController', CreativeListController)
  .controller(
    'NameCreativeGroupModalController',
    NameCreativeGroupModalController
  )
  .controller('UserCreativesController', UserCreativesController)
  .directive('creativeIcon', creativeIcon)
  .directive('creativeList', creativeList)
  .directive('exampleCreatives', exampleCreatives)
  .directive('userCreatives', userCreatives)
  .service('CreativeService', CreativeService)
  .service('CreativeGroupService', CreativeGroupService)
  .service('CreativeFormValidationService', CreativeFormValidationService)
  .service('CreativeListService', CreativeListService)
  .service('OpenGraphDataService', OpenGraphDataService)
  .service('SaveCreativeService', SaveCreativeService);
